module.exports = __webpack_public_path__ + "static/media/smriti.c96ede26.jpeg";